import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import useAssetTreeStore from "@stores/client/useAssetTreeStore";
import useBookmarkStore from "@stores/client/useBookmarkStore";

const getCheckedValue = ({ itemType, favNodes, assetPath, enabled }) => {
  if (itemType === "assets" && favNodes && assetPath) {
    return favNodes[assetPath] ?? enabled;
  }

  return enabled;
};

const useBookmarkToggle = ({ enabled, itemType, itemId, assetPath }) => {
  const { t } = useTranslation();
  const { favNodes } = useAssetTreeStore();
  const { toggleBookmark, updating } = useBookmarkStore();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(getCheckedValue({ itemType, favNodes, assetPath, enabled }));
  }, [assetPath, enabled, favNodes, itemType]);

  const handleToggle = async () => {
    if (updating) return;

    setChecked((current) => !current);

    try {
      const newFavState = await toggleBookmark({
        itemType,
        itemId,
        assetPath,
        checked,
      });
      // Outcome copy for the toast ("Bookmark added"); the button's own label
      // below uses the action copy ("Add bookmark") — they are not the same string.
      toast.success(
        checked ? t("media.bookmarkRemoved") : t("media.bookmarkAdded"),
      );
      setChecked(newFavState);
    } catch (error) {
      setChecked((current) => !current);
      console.error("Bookmark toggle failed:", error);
      toast.error(t("error.wrong"));
    }
  };

  return {
    checked,
    updating,
    handleToggle,
    label: checked ? t("media.removeBookmark") : t("media.addBookmark"),
  };
};

export default useBookmarkToggle;
